import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import {
    GetPaymentTradesHistoryRequestModel,
    GetPaymentTradesHistoryResponseModel,
} from "@/features/accounts/payment/scraping/services/get-trades-history-model";

export class GetPaymentTradesHistoryApi {
    /**
     * MoneyLook取込履歴取得API
     */
    public getPaymentTradesHistory = async (
        param: GetPaymentTradesHistoryRequestModel,
    ): Promise<GetPaymentTradesHistoryResponseModel> => {
        const path = `/api/paymentaccounts/payments/tradeshistory`;
        const res = await ApiClient.instance.get<GetPaymentTradesHistoryResponseModel>({
            path: path,
            params: param as NonNullable<unknown>,
        });

        if (res.ok === false) {
            throw MoneyLinkException.fromServer({ response: res });
        }

        return res.body;
    };
}
